import React, { useEffect, useState } from 'react'
import VehicleModel from './models/VehicleModel';

function DeleteVehicle(props) {
  const [vehicleData, setVehicleData] = useState(new VehicleModel() || []);

  useEffect(() => {
    setVehicleData(props.VehicleData);
  }, [props.VehicleData])

  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Vehicle will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Manufacturer :</b> {vehicleData.Manufacturer}</li>
            <li><b>Model Name : </b>{vehicleData.ModelName}</li>
            <li><b>Vehicle Type : </b>{vehicleData.VehicleType}</li>
            <li><b>Variant : </b>{vehicleData.Variant}</li>
            <li><b>Status : </b>{vehicleData.Status}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteVehicleDetails" hidden>{JSON.stringify(vehicleData)}</div>
    </>
  )
}

export default DeleteVehicle
